import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const partners = [
  {
    name: 'Karl Group Holdings Corp.',
    country: '🇵🇭 Philippines',
    domain: '의료장비 유통 / Medical Equipment Distribution',
    url: 'karlgroup.org',
    desc: '필리핀 의료그룹. 민다나오,마닐라,비사야스,루손 전역 의료장비 유통 및 헬스케어 솔루션 전문.',
    icon: 'ri-heart-pulse-line',
    tags: ['의료장비', '필리핀', '헬스케어'],
    image: 'https://public.readdy.ai/ai/img_res/6779bef7d87cfef6876aca1a204a6b66.jpg',
  },
  {
    name: 'Inspiraz Technology Pte Ltd',
    country: '🇸🇬 Singapore',
    domain: '머신비전 플랫폼 / Machine Vision Platform (Wizer)',
    url: 'vizcam.net / inspiraz.com',
    desc: '싱가포르 첨단 기술기업. 20년+ 머신비전·자동화개발, 아시아 전역 제조업 대상 Wizer 플랫폼.',
    icon: 'ri-eye-2-line',
    tags: ['머신비전', '싱가포르', 'AI 딥러닝'],
    image: 'https://readdy.ai/api/search-image?query=Singapore%20modern%20technology%20company%20headquarters%20sleek%20corporate%20office%20building%20glass%20facade%20night%20lights%20city%20skyline%20advanced%20engineering%20firm%20sophisticated%20urban%20environment&width=600&height=400&seq=fixcope-inspiraz-001&orientation=landscape',
  },
];

export default function Partners() {
  const headerAnim = useScrollAnimation();
  const gridAnim = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });

  return (
    <section id="partners" className="py-16 sm:py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div
          ref={headerAnim.ref}
          className={`text-center mb-16 transition-all duration-700 ${headerAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          <div className="inline-flex items-center gap-2 mb-5">
            <span className="w-8 h-[2px] bg-[#E8650A]"></span>
            <span className="text-xs font-semibold text-[#E8650A] uppercase tracking-widest whitespace-nowrap">Global Partners</span>
            <span className="w-8 h-[2px] bg-[#E8650A]"></span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-[#1A2530] mb-4">검증된 글로벌 파트너</h2>
          <p className="text-gray-500 text-[15px] max-w-lg mx-auto">
            검증된 글로벌 파트너와의 협력을 통해{' '}
            <span className="whitespace-nowrap">최고 수준의 솔루션을 제공합니다.</span>
          </p>
        </div>

        {/* Partner Cards */}
        <div
          ref={gridAnim.ref}
          className={`grid grid-cols-1 md:grid-cols-2 gap-8 transition-all duration-700 ${gridAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
          {partners.map((p, i) => (
            <div
              key={i}
              className="rounded-2xl overflow-hidden border border-gray-100 hover:border-[#E8650A]/40 transition-all duration-300 hover:-translate-y-1 group"
            >
              {/* Image */}
              <div className="h-48 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              {/* Content */}
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#E8650A]/10">
                      <i className={`${p.icon} text-lg text-[#E8650A]`}></i>
                    </div>
                    <div>
                      <h3 className="text-base font-bold text-[#1A2530] leading-tight">{p.name}</h3>
                      <span className="text-xs text-gray-400">{p.country}</span>
                    </div>
                  </div>
                </div>
                <div className="mb-3">
                  <span className="inline-block px-3 py-1 bg-[#FEF3E8] text-[#E8650A] text-[11px] sm:text-xs font-semibold rounded-full break-keep leading-tight">{p.domain}</span>
                </div>
                <p className="text-[13px] text-gray-500 leading-relaxed mb-4 whitespace-nowrap">{p.desc}</p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {p.tags.map((tag, ti) => (
                    <span key={ti} className="px-2 py-1 bg-gray-50 text-gray-500 text-[11px] rounded-md border border-gray-100 whitespace-nowrap">
                      #{tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <span className="text-xs text-gray-400">{p.url}</span>
                  <button
                    onClick={() => {
                      const el = document.querySelector('#contact');
                      if (el) el.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="flex items-center gap-1 text-xs text-[#E8650A] font-semibold hover:gap-2 transition-all whitespace-nowrap cursor-pointer"
                  >
                    파트너십 문의 <i className="ri-arrow-right-line"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Banner */}
        <div className={`mt-12 bg-[#1A2530] rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6 transition-all duration-700 delay-300 ${gridAnim.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div>
            <h4 className="text-white font-bold text-base sm:text-lg mb-2">
              글로벌 파트너십에{' '}
              <span className="whitespace-nowrap">관심이 있으신가요?</span>
            </h4>
            <p className="text-gray-400 text-sm">새로운 협력 가능성을 Fixcope와 함께 탐색해보세요.</p>
          </div>
          <button
            onClick={() => {
              const el = document.querySelector('#contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-6 py-3 bg-[#E8650A] text-white rounded-lg text-sm font-semibold hover:bg-[#C95508] transition-all whitespace-nowrap cursor-pointer shrink-0"
          >
            협력 문의하기
          </button>
        </div>
      </div>
    </section>
  );
}
